import React, { useState } from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import PostForm from "./PostForm";
import gamesData from "./gamesData";
import { t } from "../i18n";
import "./CreatePost.css";


const predefinedTags = [
  "Looking For Team",
  "Console",
  "Keyboard and Mouse",
  "No Microphone",
  "Question", 
  // "Poll", 
  // "Post",
  // "Review"
];


const getTagColor = (tag) => {
  const gameTags = Object.keys(gamesData); // Tags for games
  const typeTags = ["Post", "Poll", "Review"]; // Light blue tags
  const otherTagColors = {
    "Looking For Team": "#FEC601",
    "Console": "#9C27B0",
    "Keyboard and Mouse": "#f433ab",
    "No Microphone": "#d72638",
    "Question": "#FE9000"
  };

  if (gameTags.includes(tag)) {
    return "#10DA53"; // Light green for game tags
  } else if (typeTags.includes(tag)) {
    return "#3498db"; // Light blue for post types
  } else if (otherTagColors[tag]) {
    return otherTagColors[tag];
  }
  
  return "#ccc"; 
};


const CreatePost = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedGame, setSelectedGame] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [postTitle, setPostTitle] = useState("");
  const [postText, setPostText] = useState("");
  const [selectedTags, setSelectedTags] = useState(["Post"]);
  const [showTagDropdown, setShowTagDropdown] = useState(false);
  const [isPublic, setIsPublic] = useState(true);

  const filteredGames = Object.keys(gamesData).filter((game) =>
    game.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const toggleTag = (tag) => {
    if (tag === "Post") return; // Prevent removing "Poll" tag
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const selectGame = (game) => {
    setSelectedGame(game);
    setSearchQuery(game);
    setIsDropdownOpen(false);

    // Allow only one game to be selected
    setSelectedTags((prevTags) => {
      const updatedTags = prevTags.filter((tag) => !Object.keys(gamesData).includes(tag));
      return [game, ...updatedTags];
    });
  };

  return (
    <div>
      <div className="main-container">


        <div className="button-container">
          <Link to="/CreatePost">
            <button className="create-post-button">{t("post")}</button>
          </Link>
          <Link to="/CreatePoll">
            <button className="create-poll-button">{t("poll")}</button>
          </Link>
        </div>




        <div className="formContainer">
          <h2>{t("create_post")}</h2>

          {/* Title */}
          <label>
            {t("title")}
            <br />
            <input
              type="text"
              value={postTitle}
              onChange={(e) => setPostTitle(e.target.value)}
              placeholder={t("title_placeholder")}
              className="title-input"
            />
          </label>
          <br />

          {/* Game Selection */}
          <div className="dropdown">
            <label>{t("game")}</label>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder={t("search_game_placeholder")}
              className="search-input"
              onFocus={() => setIsDropdownOpen(true)}
              onBlur={() => setTimeout(() => setIsDropdownOpen(false), 150)}
            />
            <div className={`dropdown-content ${isDropdownOpen ? "show" : ""}`}>
              {filteredGames.length > 0 ? (
                filteredGames.map((game) => (
                  <div
                    key={game}
                    className="dropdown-item"
                    onClick={() => selectGame(game)}
                  >
                    {game}
                  </div>
                ))
              ) : (
                <div className="dropdown-item">{t("no_results_found")}</div>
              )}
            </div>
          </div>
          <br />

          {/* Tags */}
          <label>{t("tags")}</label>
          <div className="tag-dropdown-container">
            <button
              onClick={() => setShowTagDropdown(!showTagDropdown)}
              className="tag-dropdown-btn"
            >
              {showTagDropdown ? t("hide_tags") : t("select_tags")}
            </button>

            {showTagDropdown && (
              <div className="tag-dropdown-content">
                {predefinedTags.map((tag) => (
                  <div
                    key={tag}
                    className={`tag-dropdown-item ${
                      selectedTags.includes(tag) ? "selected" : ""
                    }`}
                    onClick={() => toggleTag(tag)}
                  >
                    {tag}
                  </div>
                ))}
              </div>
            )}
          </div>



          <div className="selected-tags">
            {selectedTags.map((tag, index) => (
              <span 
                key={index} 
                className="tag"
                style={{ backgroundColor: getTagColor(tag) }}
              >
                {tag}
                {/* Disable removing "Poll" tag */}
                {tag !== "Post" && (
                  <button
                    onClick={() =>
                      setSelectedTags(selectedTags.filter((t) => t !== tag))
                    }
                    className="remove-tag-btn"
                  >
                    ×
                  </button>
                )}
              </span>
            ))}
          </div>


          <br />

          {/* Body */}
          <label>
            {t("body")}
            <br />
            <textarea
              rows="10"
              cols="70"
              value={postText}
              onChange={(e) => setPostText(e.target.value)}
              placeholder={t("body_placeholder")}
              className="body-input"
            />
          </label>
          <br />

          {/* Visibility Slider */}
          <div className="slider-container">
            <label className="slider-label">{t("visibility")}:</label>
            <div className="slider-wrapper">
              <span>{t("friends_only")}</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isPublic}
                  onChange={() => setIsPublic((prev) => !prev)}
                />
                <span className="slider round"></span>
              </label>
              <span>{t("public")}</span>
            </div>
          </div>

          {/* Post Form */}
          <PostForm
            selectedGame={selectedGame}
            postTitle={postTitle}
            postText={postText}
            tags={selectedTags}
            isPublic={isPublic}
            setPostTitle={setPostTitle}
            setPostText={setPostText}
            setSelectedTags={setSelectedTags}
            setSelectedGame={setSelectedGame}
          />
        </div>

        {/* <TrendingGames />  */}
      </div>
    </div>
  );
};

export default CreatePost;
